<template>
    <div>
        <v-checkbox
            class="body-2"
            :input-value="computedValue"
            :rules="[
                !required || requiredField()
            ]"
            :data-meta-id="metadata.id"
            :id="metadata.name"
            @change="emitValue"
        >
            <template slot="label">
                <i18n path="metadataCovidScreeningSecurityConsent.label" tag="div">
                    <span>{{ (required ? '* ' : '') }}</span>
                    <div class="my-2" />
                    <div class="my-2" />
                    <div class="my-2" />
                    <a :href="getLink" target="_blank">
                        {{ $t('metadataCovidScreeningSecurityConsent.linkText') }}
                    </a>
                </i18n>
            </template>
        </v-checkbox>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';

export default {
    name: 'covid-screening-security-consent',
    mixins: [formRules],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: [String, Boolean, Number], required: false, default: 0 },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
        }),
        computedValue() {
            return this.value ? 1 : 0;
        },
        getLink() {
            const locale = this.locale === 'fr' ? 'fr' : 'en_CA';
            return `https://cv19quebec.ca/s/consent?language=${locale}`;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
